skrilla.service('customMarketService', function (cacheService, modalService) {

    const addOutcome = function (outcomes) {
        outcomes.push({})
    }

    const removeOutcome = function (outcomes, remove) {
        return outcomes.filter((it) => {
            return it !== remove
        })
    }

    const selectCompetitor = function (outcome, sport, type) {
        let modalPath = type === "PLAYER" ? "views/selectPlayerModal/selectPlayerModal.html" :
            "FRANCHISE" ? "views/selectFranchiseModal/selectFranchiseModal.html" : null
        cacheService.registerObject("sport", sport)
        modalService.openModal(modalPath, true, "lg", true, true, false, {
            sport: sport,
        }).then((competitor) => {
            outcome.player = null
            outcome.franchise = null
            if (type === "PLAYER") {
                outcome.player = competitor
                outcome.name = competitor.nickName
            } else if (type === "FRANCHISE") {
                outcome.franchise = competitor
                outcome.name = competitor.name
            }
            outcome.competitorId = competitor.id
            outcome.type = type
        })
    }


    return {
        addOutcome,
        removeOutcome,
        selectCompetitor
    };
});